import { useMemo } from 'react'

import { SupportedLocale } from '@afterpay/types'

export const useFAQLink = (locale: SupportedLocale): string =>
  useMemo(() => {
    switch (locale) {
      case 'en-AU':
        return 'https://www.afterpay.com/en-AU/help/360044314071-Can-I-change-the-date-of-a-payment-due-'
      case 'en-NZ':
        return 'https://www.afterpay.com/en-NZ/help/360044314071-Can-I-change-the-date-that-a-payment-is-due-'
      case 'en-US':
        return 'https://www.afterpay.com/en-US/help/360044314071-Can-I-change-the-date-a-payment-is-due-'
      case 'en-GB':
        return 'https://www.clearpay.co.uk/en-GB/help/900001764106-Can-I-change-the-date-that-a-payment-is-due-'
      case 'en-CA':
        return 'https://www.afterpay.com/en-CA/help/360044314071-Can-I-change-the-date-a-payment-is-due-'
      default:
        return 'https://www.afterpay.com/en-AU/help/360044314071-Can-I-change-the-date-of-a-payment-due-'
    }
  }, [locale])

export const useIdentityVerificationFAQLink = (locale: SupportedLocale): string =>
  useMemo(() => {
    switch (locale) {
      case 'en-AU':
        return 'https://www.afterpay.com/en-AU/help/360001114266-How-can-I-verify-my-account-'
      case 'en-NZ':
        return 'https://www.afterpay.com/en-NZ/help/360001114266-How-can-I-verify-my-account-'
      case 'en-US':
        return 'https://www.clearpay.co.uk/en-GB/help/900007072583-How-can-I-verify-my-account-'
      default:
        return 'https://www.afterpay.com/en-AU/help/360001114266-How-can-I-verify-my-account-'
    }
  }, [locale])
